import { getBrandFromUrl } from './loadBrandConfig.js'

/**
 * Gets the full chat version string based on the current URL path and brand
 * @param {string | null} brandName - The brand name from URL params
 * @returns {string} The full chat version string
 */

// TODO: Need to test this on staging and add metabase reporting endpoint

export function getChatVersion(brandName) {
  const path = window.location.pathname
  const pathBrand = getBrandFromUrl()

  let suffix = ''

  if (path.includes('/chat-now')) {
    suffix = 'Chat-Now'
  } else if (path.includes('/chat/brandless') || pathBrand === 'brandless') {
    suffix = 'Brandless'
  } else if (path.includes('/chat/') && pathBrand) {
    // Special cases for NDR tests
    if (pathBrand === 'national-debt-relief') {
      suffix = 'National Debt Relief'
    } else if (pathBrand === 'td-ndr') {
      suffix = 'TD NDR'
    } else {
      // Default to cobranded
      suffix = 'Cobranded'
    }
  }
  // should handle /chat/ only
  else if (path.includes('/chat')) {
    suffix = 'Branded'
  }
  // Default fallback
  else {
    suffix = 'Unlabeled'
  }

  // Return full chat version with brand name if provided
  if (brandName) {
    // if brandName includes "blank", use pathBrand as suffix
    if (brandName.toLowerCase().includes('blank') && pathBrand) {
      return `${brandName.toUpperCase().replace(/-/g, ' ')} - ${pathBrand.toUpperCase().replace(/-/g, ' ')} - Funnels`
    }

    return `${brandName.toUpperCase().replace(/-/g, ' ')} - ${suffix} - Funnels`
  }

  return `${suffix} - Funnels`
}
